import type { FC, ReactElement } from 'react';
import { cloneElement } from 'react';
import { Badge } from '@george-labs.com/design-system';

import type { BadgeDefinition } from '@shared/products-types';

interface Props {
    'data-cy': string;
    className?: string;
    badgeClassName?: string;
    badges?: BadgeDefinition[];
}

interface BadgeProps {
    'data-cy': string;
    className: string;
}

export const ProductBadges: FC<Props> = ({
    'data-cy': dataCy,
    className,
    badgeClassName = 'mr-2',
    badges = [],
}) => {
    if (badges.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {badges.map((badge) => {
                if (badge.type === 'CUSTOM') {
                    return cloneElement(badge.badge as ReactElement<BadgeProps>, {
                        key: `label-${badge.type}-${badge.value}`,
                        'data-cy': `${dataCy}-${badge.value.toLowerCase()}`,
                        className: badgeClassName,
                    });
                }

                return (
                    <Badge
                        key={`label-${badge.type}-${badge.text}`}
                        data-cy={`${dataCy}-${badge.value.toLowerCase()}`}
                        className={badgeClassName}
                        variant={badge.type}
                    >
                        {badge.text}
                    </Badge>
                );
            })}
        </div>
    );
};
